module.exports = __webpack_public_path__ + "img/logo.87ad3cd4.png";